import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   position: relative;
   
   .line {
      position: relative;
      display: flex;
      align-items: center;
      margin: 30px 0 15px;
      font-size: 16px;
      white-space: nowrap;

      &::before {
         content: '';
         width: 100%;
         height: 1px;
         background-color: rgb(200, 200, 200);
         margin-right: 15px;
      }
      &::after {
         content: '';
         width: 100%;
         height: 1px;
         background-color: rgb(200, 200, 200);
         margin-left: 15px;
      }
      span {
         opacity: 0.6;
      }
   }
`;

export const SectionHeader = styled.div`
   display: flex;
   align-items: center;
   margin-bottom: 12px;
   gap: 8px;

   h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #374151;
   }
`;

export const ReceiverSection = styled.div`
   margin-top: 20px;
`;

export const ReceiverIndexBadge = styled.div`
   background: #f3f4f6;
   border: 1px solid #e5e7eb;
   border-radius: 6px;
   padding: 8px 12px;
   font-size: 13px;
   color: #6b7280;
   margin-bottom: 16px;

   span {
      font-weight: 600;
      color: #374151;
   }
`;

export const ScrollableFieldsContainer = styled.div`
   max-height: 280px;
   overflow-y: auto;
   padding-right: 4px;

   &::-webkit-scrollbar { width: 6px; }
   &::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 3px; }
   &::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 3px; &:hover { background: #a8a8a8; } }
`;

export const FieldContainer = styled.div`
   border: 1px solid #e5e7eb;
   border-radius: 8px;
   padding: 14px;
   margin-bottom: 10px;
   background-color: #f9fafb;
`;

export const FieldHeader = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 10px;

   span {
      font-size: 13px;
      font-weight: 500;
      color: #6b7280;
   }
`;

export const ButtonGroup = styled.div`
   display: flex;
   gap: 6px;
`;

export const ActionButton = styled.button`
   width: 24px;
   height: 24px;
   border: none;
   border-radius: 4px;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 14px;

   &.add-btn {
      background-color: #f3f4f6;
      color: #374151;
      &:hover { background-color: #e5e7eb; }
   }

   &.remove-btn {
      background-color: #fee2e2;
      color: #dc2626;
      &:hover { background-color: #fecaca; }
   }
`;

export const FieldGroup = styled.div`
   margin-bottom: 10px;
   &:last-child { margin-bottom: 0; }

   label {
      display: block;
      font-size: 13px;
      font-weight: 500;
      color: #374151;
      margin-bottom: 4px;
   }
`;

export const MappingRow = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr auto;
   gap: 8px;
   align-items: center;
   margin-bottom: 8px;

   &:last-child { margin-bottom: 0; }

   .textInput {
      margin-top: 0;
   }
`;

export const MappingInput = styled.input`
   width: 100%;
   padding: 7px 10px;
   border: 1px solid #e5e7eb;
   border-radius: 6px;
   font-size: 13px;
   color: #374151;
   background: #fff;
   box-sizing: border-box;

   &:focus {
      outline: none;
      border-color: #6b7280;
   }

   &::placeholder { color: #9ca3af; }
`;

export const RemoveBtn = styled.button`
   width: 24px;
   height: 24px;
   border: none;
   border-radius: 4px;
   background-color: #fee2e2;
   color: #dc2626;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 14px;
   flex-shrink: 0;
   &:hover { background-color: #fecaca; }
`;

export const AddMappingBtn = styled.button`
   margin-top: 10px;
   width: 100%;
   padding: 7px;
   border: 1px dashed #d1d5db;
   border-radius: 6px;
   background: transparent;
   color: #6b7280;
   font-size: 13px;
   cursor: pointer;
   &:hover { border-color: #9ca3af; color: #374151; }
`;